import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'main-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/layout/layout.component.ts